import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Match } from '../../_shared/models/match.model';

@Injectable({
    providedIn: 'root'
})
export class DownloadMatchService {
    private downloadedMatchObservable$ = new Subject<any>();

    constructor(
        private http: HttpClient
    ) { }

    downloadMatch(match: Match, partner: string) {
        const preparedMatch = this.prepareMatch(match);
        return this.http.post<any>('api_endpoint' + '/match/download-match', { match: preparedMatch, sides: match.sides, partner, drawId: match.source.drawId, structureId: match.source.structureId });
    }

    private prepareMatch(match: Match) {
        const preparedMatch = {
            indoorOutdoor: match.indoorOutdoor,
            matchFormat: match.matchFormat,
            matchStatus: match.matchStatus,
            matchType: match.matchType,
            surfaceCategory: match.surfaceCategory,
            matchId: match.matchId,
            tournament: match.tournament,
            event: match.event,
            roundName: match.roundName,
            roundNumber: match.roundNumber,
            roundPosition: match.roundPosition,
            schedule: match.schedule
        };

        return preparedMatch;

    }

    publishFollow(match: Match) {
        this.downloadedMatchObservable$.next(match);
    }

    subscribeFollow(): Observable<any> {
        return this.downloadedMatchObservable$.asObservable();
    }

}
